import { render, staticRenderFns } from "./OrderDetailDialog.vue?vue&type=template&id=7f083c01&scoped=true&"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailDialog.vue?vue&type=style&index=0&id=7f083c01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f083c01",
  null
  
)

export default component.exports